import React from "react";
import { useTranslation } from "react-i18next";
import {
    Box,
    Chip,
    Paper,
    Tooltip,
    Typography
} from "@material-ui/core";
import { InvoiceCuttingStatus } from "components/InvoiceCuttingDialog/utils";
import SettingsIcon from '@material-ui/icons/Settings';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from "@material-ui/core/IconButton";
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import useStyles from "./style";


function InvoiceCuttingCard({ invoiceCutting, onOpen, onDelete }) {
    const { t } = useTranslation();
    const classes = useStyles();

    const getStatusIcon = () => {
        switch (invoiceCutting?.status) {
            case InvoiceCuttingStatus.PENDING_VALIDATION:
                return <HourglassEmptyIcon />;
            case InvoiceCuttingStatus.IN_PROGRESS:
            case InvoiceCuttingStatus.VALIDATED:
                return <SettingsIcon className={classes.rotateIcon} />;
            case InvoiceCuttingStatus.FAILED:
                return <ErrorIcon style={{color:"#ef2929"}} />;
            default:
                return <></>;
        }
    };

    const getStatusLabel = () => {
        switch (invoiceCutting?.status) {
            case InvoiceCuttingStatus.IN_PROGRESS:
                return t("invoiceCutting.cutting-in-progress");
            case InvoiceCuttingStatus.PENDING_VALIDATION:
                return t("invoiceCutting.pending-validation");
            case InvoiceCuttingStatus.VALIDATED:
                return t("invoiceCutting.integration-in-progress");
            case InvoiceCuttingStatus.FAILED:
                return t("invoiceCutting.integration-failed");
            default:
                return <></>;
        }
    };

    const handleDelete = (e) => {
        e.stopPropagation();
        onDelete();
    };

    return (
        <Box
            component={Paper}
            onClick={onOpen}
            className={classes.card}
        >
            <Typography variant="body2">
                {invoiceCutting.createdAt}
            </Typography>

            <Box display="flex" alignItems="center">
                <Chip
                    label={getStatusLabel()}
                    icon={getStatusIcon()}
                    variant="outlined"
                    size="small"
                    className={classes.statusChip}
                    color="primary"
                    style={{ marginRight: invoiceCutting.status === "FAILED" ? '4px' : 0 }}
                />

                {invoiceCutting.status === "FAILED" && (
                    <Tooltip title={t("invoiceCutting.delete")}>
                        <IconButton 
                            size="small" 
                            onClick={handleDelete}
                        >
                            <DeleteIcon fontSize="small" style={{ color: '#ef2929' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
        </Box>
    );}

export default InvoiceCuttingCard;